export const news = [
  {
    id: "news-press-conference",
    title: "舒淇新片发布会闪耀举行，分享角色幕后故事",
    category: "动态",
    date: "2026-09-28",
    summary:
      "舒淇出席最新电影发布会，身穿一袭黑色礼服惊艳全场，并在现场分享了为塑造角色所做的诸多准备工作，畅谈与导演合作的感受。",
    cover:
      "https://readdy.ai/api/search-image?query=an%20elegant%20film%20press%20conference%20stage%20with%20warm%20spotlights%20and%20a%20softly%20blurred%20audience%20editorial%20news%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-press-conference-2024&orientation=landscape",
    content: [
      "近日，舒淇出席最新电影的北京发布会。她一袭简约黑色礼服亮相红毯，优雅从容的气质引来全场掌声。",
      "在媒体提问环节，舒淇坦言这次的角色挑战极大，为了贴近人物状态，她提前数月进行形体与台词训练，并多次与导演深入探讨角色的心理动机。",
      "「每一个角色对我来说都是一次重新出发，我希望观众能在荧幕上看到一个真实的、有呼吸感的人物。」舒淇在现场说道。",
      "据悉，这部新作将于年内与观众见面，影片题材新颖，舒淇在其中的表演被提前观看的内部观众评价为「又一次突破」。",
    ],
  },
  {
    id: "news-cannes",
    title: "舒淇亮相国际电影节，优雅造型成为全场焦点",
    category: "活动",
    date: "2026-08-15",
    summary:
      "舒淇受邀出席国际电影节开幕活动，以一身定制礼服造型登场，展现东方女性的独特魅力，成为摄影镜头追逐的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=an%20elegant%20red%20carpet%20event%20at%20night%20with%20warm%20golden%20lights%20and%20blurred%20photographers%20editorial%20event%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-cannes-2024&orientation=landscape",
    content: [
      "国际电影节开幕当晚，舒淇以一袭定制高级礼服亮相红毯，优雅的线条与从容的气场令她瞬间成为全场焦点。",
      "造型团队透露，这套礼服的灵感源自东方美学，通过简洁的剪裁与柔和的色调，突出舒淇本人的独特气质。",
      "在活动间隙，舒淇与多位国际影人友好交流，分享了对电影艺术的理解，并表达了对未来跨文化合作项目的期待。",
      "多年来，舒淇始终活跃于国际影坛，是华语演员中极具国际辨识度的面孔之一。",
    ],
  },
  {
    id: "news-interview",
    title: "深度访谈：舒淇谈表演、生活与时间",
    category: "访谈",
    date: "2026-06-20",
    summary:
      "在一场深度专访中，舒淇回顾了自己的表演历程，分享对生活与时间的理解，坦言「演戏让我学会了和自己和解」。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20calm%20portrait%20setting%20with%20a%20soft%20window%20and%20warm%20morning%20light%20editorial%20interview%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-interview-2024&orientation=landscape",
    content: [
      "在采访中，舒淇少有地谈起了自己对表演的理解。她认为，表演不是「演」，而是让自己真正地活在角色的世界里。",
      "回顾多年来的作品，她坦言每一个阶段都有不同的困惑与收获，「年轻的时候急着证明自己，现在更想安静地做好一件事。」",
      "谈到生活，舒淇说自己越来越珍惜平淡的日常，阅读、散步、与家人相处，都是她补充能量的方式。",
      "「时间会带走很多东西，但也会留下最真实的自己。」她这样总结道。",
    ],
  },
  {
    id: "news-award",
    title: "舒淇获颁年度电影人物，致敬多年艺术贡献",
    category: "动态",
    date: "2026-05-09",
    summary:
      "在年度电影盛典上，舒淇获颁「年度电影人物」荣誉，以表彰她多年来对华语电影的卓越贡献与持续的艺术探索。",
    cover:
      "https://readdy.ai/api/search-image?query=an%20elegant%20award%20ceremony%20stage%20with%20warm%20golden%20light%20and%20a%20trophy%20silhouette%20editorial%20award%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-award-2023&orientation=landscape",
    content: [
      "年度电影盛典当晚，舒淇凭借多年来在华语影坛的卓越表现，获颁「年度电影人物」荣誉。",
      "颁奖词中这样评价她：「她以细腻而有力的表演，塑造了一个又一个令人难忘的银幕形象，是华语电影不可或缺的重要力量。」",
      "上台领奖时，舒淇感谢了一路支持她的观众与合作团队，并表示会继续以作品回馈大家的期待。",
      "这一荣誉，是对她演艺生涯又一次重要的肯定。",
    ],
  },
  {
    id: "news-new-project",
    title: "舒淇确认加盟新制作，题材引发广泛期待",
    category: "动态",
    date: "2026-03-18",
    summary:
      "消息确认舒淇将加盟一部全新制作的电影项目，影片聚焦女性成长主题，主创阵容备受关注，消息一出便引发影迷热烈讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20film%20production%20clapperboard%20and%20soft%20studio%20lighting%20on%20a%20warm%20set%20editorial%20news%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-new-project-2023&orientation=landscape",
    content: [
      "据片方消息，舒淇已确认加盟一部全新的电影制作，影片将围绕女性成长与自我寻找的主题展开。",
      "业内人士表示，这一题材与舒淇近年来的选片方向高度契合，她擅长诠释复杂而立体的女性人物。",
      "消息公布后，社交平台上关于该项目的讨论迅速升温，不少影迷表达了强烈期待。",
      "影片预计将于明年进入正式拍摄阶段，更多细节将在后续陆续公开。",
    ],
  },
  {
    id: "news-fashion",
    title: "舒淇登时尚杂志封面，演绎简约高级美学",
    category: "活动",
    date: "2026-01-25",
    summary:
      "舒淇最新一组杂志大片释出，以极简造型演绎高级时尚美学，举手投足间尽显成熟女性的从容与魅力。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20minimal%20fashion%20editorial%20studio%20scene%20with%20soft%20beige%20backdrop%20and%20warm%20light%20editorial%20fashion%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-fashion-2023&orientation=landscape",
    content: [
      "最新一期时尚杂志封面由舒淇担纲出镜，整组大片以极简的色调与构图，突出人物的气质与状态。",
      "拍摄现场，舒淇与摄影团队默契十足，多组造型在自然光下完成，呈现出松弛又不失精致的视觉效果。",
      "「美是一种状态，而不是一种标准。」舒淇在采访中分享了自己对美的理解，获得网友一致认同。",
      "该组大片发布后迅速登上多个平台的热门话题。",
    ],
  },
  {
    id: "news-festival",
    title: "舒淇担任影展评审，专业视角获一致好评",
    category: "活动",
    date: "2025-12-05",
    summary:
      "舒淇受邀担任某国际影展评审，从演员的专业视角出发参与影片评选，认真严谨的态度获得业内与观众的一致好评。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20calm%20film%20festival%20jury%20panel%20table%20with%20warm%20soft%20lighting%20editorial%20event%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-festival-2022&orientation=landscape",
    content: [
      "舒淇受邀担任某国际影展评审，与来自不同国家的电影人共同参与主竞赛单元的评选工作。",
      "评审期间，她每天观看大量参赛影片，并认真记录观感，从演员的独特视角提出专业意见。",
      "「看别人的电影，也会让我重新思考自己的表演。」舒淇在评审工作结束后这样说。",
      "主办方表示，舒淇的专业与敬业给评审团留下了深刻印象。",
    ],
  },
  {
    id: "news-retrospective",
    title: "舒淇作品回顾展举办，经典角色再度引热议",
    category: "动态",
    date: "2025-11-02",
    summary:
      "一场舒淇作品回顾展在城市影院举办，多部经典代表作集中展映，让观众重温她塑造的一个个鲜活银幕形象。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cozy%20retro%20cinema%20hall%20with%20warm%20dim%20lights%20and%20empty%20velvet%20seats%20editorial%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=500&seq=news-retrospective-2022&orientation=landscape",
    content: [
      "舒淇作品回顾展近日在城市影院举办，集中展映了多部横跨不同年代的经典代表作。",
      "展映期间，不少观众在社交平台分享观影感受，重温了那些陪伴自己成长的经典角色。",
      "有影评人指出，舒淇的作品之所以历久弥新，在于她总能赋予角色真实的生命力。",
      "主办方表示，希望通过此类回顾展，让更多观众重新认识华语电影的经典之美。",
    ],
  },
] as const;